import {
  IAttendee,
  IMeeetingAgenda,
  ISchedule,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { Dropdown } from 'core-components/library/dropdown'
import { Input } from 'core-components/library/inputs'
import { Crud } from 'core/types/Crud'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'
import { onChangeRangedField } from '../../../../helpers/onChangeRangedField'
import { IColumn } from '../../../styledComponents/styledTable/types'
import styles from '../MeetingAgenda.module.scss'

import { getSchedule } from './getSchedule'

interface IGetAgendaColumns {
  onChange: (field: string, index: number) => (value: string | number) => void
  participantsCrud: Crud<IAttendee, number | string>
}
export const getAgendaColumns = ({
  onChange,
  participantsCrud,
}: IGetAgendaColumns): IColumn<IMeeetingAgenda>[] => {
  return [
    {
      title: getFormedEltTranslation('agenda-table-topic'),
      field: 'Topic',
      renderComponent: ({ value, index }) => (
        <Input
          classes={{
            root: styles.category,
          }}
          value={(value as string) || ''}
          onChange={onChange('Topic', index)}
        />
      ),
    },
    {
      title: getFormedEltTranslation('agenda-table-time'),
      field: 'Time',
      renderComponent: ({ value, index }) => (
        <Input
          value={value as number}
          type={'number'}
          onChange={onChangeRangedField({
            onChange: onChange('Time', index),
            range: { start: 0, end: 5000 },
          })}
        />
      ),
    },
    {
      title: getFormedEltTranslation('agenda-table-schedule'),
      field: 'Schedule',
      renderComponent: ({ value }) => (
        <p className={styles.schedule}>{getSchedule(value as ISchedule)}</p>
      ),
    },
    {
      title: getFormedEltTranslation('agenda-table-presenter'),
      field: 'Presenter',
      renderComponent: ({ value, index }) => (
        <Dropdown
          caption={'Name'}
          source={participantsCrud}
          classes={{
            controlClasses: {
              root: styles.presenter,
            },
          }}
          value={(value as string) || ''}
          onChange={onChange('Presenter', index)}
        />
      ),
    },
  ]
}
